import FolderSimple from "./FolderSimple.svelte"
export default FolderSimple;